﻿import { OutputField } from "@models/configurators/output-fields/output-field";
import { KbObjectManager } from "@models/configurators/kb-object-manager";
import { eDynamicSource, eOutputFieldType } from "@models/enums";
import { IExcelImageField } from "@models/entity-models";
import { KboOutputField } from "@models/configurators/configurator-di";
import { CToken } from "@models/configurators/ctoken";

@KboOutputField(CToken.ExcelImageField, eOutputFieldType.excelImage)
export class ExcelImageField extends OutputField implements IExcelImageField {
    constructor(kom: KbObjectManager) {
        super(kom);
    }

    public filePath: string;
    public source: string = eDynamicSource.template;
    public sourceId: string;

    public sheetName: string;

    public upperLeftCell: string;

    public lowerRightCell: string;
}
